import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Button,
  Dropdown
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardReceiptGroupSettingUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div>
        <div
          id="CardReceiptGroupSettingUX-div-1"
          style={{boxShadow: "none", padding: "10px"}}>
          
          <div
            className="ui form small"
            id="CardReceiptGroupSettingUX-div-2">
            {}
            <FormGroup
              id="CardReceiptGroupSettingUX-FormGroup-3"
              inline={true}>
              <FormField
                id="CardReceiptGroupSettingUX-FormField-43"
                inline={true}
                width={2}>
                <div
                  id="CardReceiptGroupSettingUX-div-53"
                  style={{fontWeight: "bold", fontSize: "1.2rem", display: "flex", justifyContent: "space-between"}}>
                  {props.languageUX === "en" ? "Set up a receipt set" : "ตั้งค่าชุดใบเสร็จ"}
                </div>
              </FormField>
              <FormField
                id="CardReceiptGroupSettingUX-FormField-44"
                inline={true}
                style={{ display: "flex", justifyContent: "center" }}
                width={2}>
                <div
                  id="CardReceiptGroupSettingUX-div-52">
                  {props.languageUX === "en" ? "Payment Point (Device)" : "จุดรับชำระเงิน (Device)"}
                </div>
              </FormField>
              <FormField
                id="CardReceiptGroupSettingUX-FormField-45"
                inline={true}
                width="2">
                <div
                  id="CardReceiptGroupSettingUX-div-51"
                  style={{ display: "flex", background: "#F1F1F1", padding: "5px", borderRadius: 4,  width: "100%", justifyContent: "center" }}>
                  {props.stationName?.name || "-"}
                </div>
              </FormField>
              <FormField
                id="CardReceiptGroupSettingUX-FormField-46"
                inline={true}
                style={{ display: "flex", justifyContent: "center" }}
                width={2}>
                <div
                  id="CardReceiptGroupSettingUX-div-50">
                  {props.languageUX === "en" ? "Cash collection point number" : "หมายเลขจุดรับเงิน"}
                </div>
              </FormField>
              <FormField
                id="CardReceiptGroupSettingUX-FormField-48"
                inline={true}
                width={1}>
                <div
                  id="CardReceiptGroupSettingUX-div-49"
                  style={{ display: "flex", background: "#F1F1F1", padding: "5px", borderRadius: 4,  width: "100%", justifyContent: "center" }}>
                  {props.stationName?.number || "-"}
                </div>
              </FormField>
              <FormField
                id="CardReceiptGroupSettingUX-FormField-54"
                inline={true}
                style={{ display: "flex", justifyContent: "center" }}
                width={2}>
                <div
                  id="CardReceiptGroupSettingUX-div-61">
                  {props.languageUX === "en" ? "Name of cash collection point" : "ชื่อจุดรับเงิน"}
                </div>
              </FormField>
              <FormField
                id="CardReceiptGroupSettingUX-FormField-55"
                inline={true}
                width={4}>
                <div
                  id="CardReceiptGroupSettingUX-div-60"
                  style={{ display: "flex", background: "#F1F1F1", padding: "5px", borderRadius: 4,  width: "100%", justifyContent: "center" }}>
                  {props.stationName?.station_name || "-"}
                </div>
              </FormField>
              <FormField
                id="CardReceiptGroupSettingUX-FormField-57"
                inline={true}
                style={{ display: "flex", justifyContent: "flex-end" }}
                width={3}>
                <Button
                  color="blue"
                  id="CardReceiptGroupSettingUX-Button-62"
                  onClick={props.openModReceiptEdit}
                  size="mini">
                  {props.languageUX === "en" ? "Add a receipt set" : "เพิ่มชุดใบเสร็จรับเงิน"}
                </Button>
              </FormField>
            </FormGroup>
            <div
              id="CardReceiptGroupSettingUX-div-82"
              style={{ padding: "0px 0px 15px"}}>
              
              <hr
                id="CardReceiptGroupSettingUX-hr-83">
              </hr>
            </div>
            <FormGroup
              id="CardReceiptGroupSettingUX-FormGroup-66"
              inline={true}>
              <FormField
                id="CardReceiptGroupSettingUX-FormField-67"
                inline={true}
                width={1}>
                <div
                  id="CardReceiptGroupSettingUX-div-74">
                  {props.languageUX === "en" ? "fiscal year" : "ปีงบประมาณ"}
                </div>
              </FormField>
              <FormField
                id="CardReceiptGroupSettingUX-FormField-68"
                inline={true}
                width={2}>
                <div
                  id="CardReceiptGroupSettingUX-div-84"
                  style={{ width: "100%" }}>
                  
                  <Dropdown
                    clearable={true}
                    fluid={true}
                    id="CardReceiptGroupSettingUX-Dropdown-86"
                    name="budgetYear"
                    onChange={props.onChangeDataSearch}
                    options={props.yearOptions}
                    search={true}
                    selection={true}
                    value={props.searchData?.budgetYear}>
                  </Dropdown>
                </div>
              </FormField>
              <FormField
                id="CardReceiptGroupSettingUX-FormField-69"
                inline={true}
                style={{ display: "flex", justifyContent: "center" }}
                width={1}>
                <div
                  id="CardReceiptGroupSettingUX-div-75">
                  {props.languageUX === "en" ? "status" : "สถานะ"}
                </div>
              </FormField>
              <FormField
                id="CardReceiptGroupSettingUX-FormField-70"
                inline={true}
                width={2}>
                <div
                  id="CardReceiptGroupSettingUX-div-85"
                  style={{ width: "100%" }}>
                  
                  <Dropdown
                    fluid={true}
                    id="CardReceiptGroupSettingUX-Dropdown-87"
                    name="status"
                    onChange={props.onChangeDataSearch}
                    options={props.receiptGroupStatus}
                    search={true}
                    selection={true}
                    value={props.searchData?.status}>
                  </Dropdown>
                </div>
              </FormField>
              <FormField
                id="CardReceiptGroupSettingUX-FormField-71"
                inline={true}
                style={{ display: "flex", justifyContent: "center" }}
                width={2}>
                <div
                  id="CardReceiptGroupSettingUX-div-76">
                  {props.languageUX === "en" ? "Receipt issue date" : "วันเบิกใบเสร็จ"}
                </div>
              </FormField>
              <FormField
                id="CardReceiptGroupSettingUX-FormField-72"
                inline={true}
                width={2}>
                <div
                  id="CardReceiptGroupSettingUX-div-77"
                  style={{ width: "100%" }}>
                  
                  <DateTextBox
                    id="CardReceiptGroupSettingUX-DateTextBox-81"
                    onChange={props.onChangeDateSearch}
                    value={props.searchData?.date}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardReceiptGroupSettingUX-FormField-73"
                inline={true}
                style={{ display: "flex", justifyContent: "flex-end" }}
                width={2}>
                <div
                  id="CardReceiptGroupSettingUX-div-88">
                  {props.buttonSearch}
                </div>
              </FormField>
            </FormGroup>
          </div>
          <div
            id="CardReceiptGroupSettingUX-div-65">
            
          </div>
          <div
            id="CardReceiptGroupSettingUX-div-31">
            
            <Table
              data={props.receiptGroupData}
              headers="เปิดใช้งานได้,ปีงบประมาณ,เล่มที่,เลขที่เริ่มต้น,เลขที่สิ้นสุด,เลขที่กำลังใช้งาน,ผู้เบิกใบเสร็จ,วันเวลาที่เบิกใบเสร็จ,สถานะ,"
              id="tb-bilQueueReq"
              keys="isOn,year,prefix,running_start,running_end,current_running,user,date,status,action"
              minRows="10"
              onPageChange={props.onPageChange}
              onPageSizeChange={props.onPageSizeChange}
              page={props.paginatedItems?.page || 0}
              pageSize={props.paginatedItems?.pageSize || 0}
              pages={Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)}
              showPagination={true}
              style={{height: "65vh"}}>
            </Table>
          </div>
        </div>
      </div>
    )
}


export default CardReceiptGroupSettingUX

export const screenPropsDefault = {}

/* Date Time : Mon Aug 18 2025 09:30:52 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{boxShadow: \"none\", padding: \"10px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form small"
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-div-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-FormGroup-3"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-div-31"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 32,
      "name": "Table",
      "parent": 31,
      "props": {
        "data": {
          "type": "code",
          "value": "props.receiptGroupData"
        },
        "defaultPageSize": {
          "type": "value",
          "value": ""
        },
        "getTdProps": {
          "type": "code",
          "value": ""
        },
        "getTrProps": {
          "type": "code",
          "value": ""
        },
        "headers": {
          "type": "value",
          "value": "เปิดใช้งานได้,ปีงบประมาณ,เล่มที่,เลขที่เริ่มต้น,เลขที่สิ้นสุด,เลขที่กำลังใช้งาน,ผู้เบิกใบเสร็จ,วันเวลาที่เบิกใบเสร็จ,สถานะ,"
        },
        "id": {
          "type": "value",
          "value": "tb-bilQueueReq"
        },
        "keys": {
          "type": "value",
          "value": "isOn,year,prefix,running_start,running_end,current_running,user,date,status,action"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "onPageChange": {
          "type": "code",
          "value": "props.onPageChange"
        },
        "onPageSizeChange": {
          "type": "code",
          "value": "props.onPageSizeChange"
        },
        "page": {
          "type": "code",
          "value": "props.paginatedItems?.page || 0"
        },
        "pageSize": {
          "type": "code",
          "value": "props.paginatedItems?.pageSize || 0"
        },
        "pages": {
          "type": "code",
          "value": "Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)"
        },
        "showPagination": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{height: \"65vh\"}"
        },
        "widths": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-FormField-43"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-FormField-44"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-FormField-45"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-FormField-46"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-FormField-48"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 48,
      "props": {
        "children": {
          "type": "code",
          "value": "props.stationName?.number || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-div-49"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", background: \"#F1F1F1\", padding: \"5px\", borderRadius: 4,  width: \"100%\", justifyContent: \"center\" }"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "div",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเลขจุดรับเงิน",
          "valueEN": "Cash collection point number"
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-div-50"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 45,
      "props": {
        "children": {
          "type": "code",
          "value": "props.stationName?.name || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-div-51"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", background: \"#F1F1F1\", padding: \"5px\", borderRadius: 4,  width: \"100%\", justifyContent: \"center\" }"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 44,
      "props": {
        "children": {
          "type": "value",
          "value": "จุดรับชำระเงิน (Device)",
          "valueEN": "Payment Point (Device)"
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-div-52"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": "ตั้งค่าชุดใบเสร็จ",
          "valueEN": "Set up a receipt set"
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-div-53"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\", display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-FormField-54"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-FormField-55"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-FormField-57"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\" }"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "div",
      "parent": 55,
      "props": {
        "children": {
          "type": "code",
          "value": "props.stationName?.station_name || \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-div-60"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", background: \"#F1F1F1\", padding: \"5px\", borderRadius: 4,  width: \"100%\", justifyContent: \"center\" }"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 54,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อจุดรับเงิน",
          "valueEN": "Name of cash collection point"
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-div-61"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "Button",
      "parent": 57,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มชุดใบเสร็จรับเงิน",
          "valueEN": "Add a receipt set"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-Button-62"
        },
        "onClick": {
          "type": "code",
          "value": "props.openModReceiptEdit"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-div-65"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-FormGroup-66"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "FormField",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-FormField-67"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "FormField",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-FormField-68"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "FormField",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-FormField-69"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\" }"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "FormField",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-FormField-70"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 71,
      "name": "FormField",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-FormField-71"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"center\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 72,
      "name": "FormField",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-FormField-72"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "FormField",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-FormField-73"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"flex-end\" }"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "div",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": "ปีงบประมาณ",
          "valueEN": "fiscal year"
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-div-74"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "div",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ",
          "valueEN": "status"
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-div-75"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "div",
      "parent": 71,
      "props": {
        "children": {
          "type": "value",
          "value": "วันเบิกใบเสร็จ",
          "valueEN": "Receipt issue date"
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-div-76"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "div",
      "parent": 72,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-div-77"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 81,
      "name": "DateTextBox",
      "parent": 77,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-DateTextBox-81"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDateSearch"
        },
        "value": {
          "type": "code",
          "value": "props.searchData?.date"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-div-82"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"0px 0px 15px\"}"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "hr",
      "parent": 82,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-hr-83"
        }
      },
      "seq": 83,
      "void": true
    },
    {
      "from": null,
      "id": 84,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-div-84"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "div",
      "parent": 70,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-div-85"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "Dropdown",
      "parent": 84,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-Dropdown-86"
        },
        "name": {
          "type": "value",
          "value": "budgetYear"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDataSearch"
        },
        "options": {
          "type": "code",
          "value": "props.yearOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.searchData?.budgetYear"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "Dropdown",
      "parent": 85,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-Dropdown-87"
        },
        "name": {
          "type": "value",
          "value": "status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDataSearch"
        },
        "options": {
          "type": "code",
          "value": "props.receiptGroupStatus"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.searchData?.status"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "div",
      "parent": 73,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardReceiptGroupSettingUX-div-88"
        }
      },
      "seq": 88,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "memo": false,
  "name": "CardReceiptGroupSettingUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
